export function stripLatinDiacritics(value) {
  const decomposed = String(value || '').normalize('NFD');
  let output = '';
  let previousBaseWasLatin = false;

  for (const char of decomposed) {
    if (/\p{M}/u.test(char)) {
      if (!previousBaseWasLatin) output += char;
      continue;
    }
    previousBaseWasLatin = /\p{Script=Latin}/u.test(char);
    output += char;
  }
  return output.normalize('NFC');
}

export function normalizeSearchText(value) {
  return stripLatinDiacritics(
    String(value || '').normalize('NFC').toLowerCase()
  )
    .trim()
    .replace(/\s+/gu, ' ');
}

export function fallbackSearchIndex(item) {
  const candidates = [
    item?.name,
    item?.nameEn,
    item?.name_en,
    item?.title,
    item?.titleEn,
    item?.title_en,
  ];
  return Array.from(new Set(candidates.map(normalizeSearchText).filter(Boolean)));
}

export function itemSearchIndex(item) {
  const provided = Array.isArray(item?.searchIndex)
    ? item.searchIndex.map(normalizeSearchText).filter(Boolean)
    : [];
  return provided.length > 0
    ? Array.from(new Set(provided))
    : fallbackSearchIndex(item);
}

function tokenize(value) {
  return normalizeSearchText(value).match(/[\p{L}\p{N}]+/gu) || [];
}

function wordsMatchInOrder(words, queryWords) {
  if (!queryWords.length) return false;
  let wordIndex = 0;
  for (const queryWord of queryWords) {
    while (wordIndex < words.length && !words[wordIndex].startsWith(queryWord)) {
      wordIndex += 1;
    }
    if (wordIndex >= words.length) return false;
    wordIndex += 1;
  }
  return true;
}

export function getSearchRank(item, query) {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) return null;

  let bestRank = null;
  const queryWords = tokenize(normalizedQuery);
  for (const candidate of itemSearchIndex(item)) {
    if (candidate.startsWith(normalizedQuery)) return 0;
    if (wordsMatchInOrder(tokenize(candidate), queryWords)) bestRank = 1;
  }
  return bestRank;
}
